document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (event) => {
    var selector = ".pagination details",
      dropdown_wrapper = event.target.closest(`${selector}`);
    if (!dropdown_wrapper){
      document.querySelectorAll(selector).forEach(elem => {
        if(elem.open){
          elem.open = false;
        }
      })
    }else{
      //dropdown_wrapper.open = true;
    }
  });
});